import Typography from "@material-ui/core/Typography";
// @ts-ignore
import CopyToClipboardChip from "hcla-web-frontend-primitives/app/components/primitives/Chips/CopyToClipboardChip";
import React from "react";
import {createStyles, Theme, WithStyles} from "@material-ui/core";
import CutsetItemChip from "../Chips/CutsetItemChip";
import {QRLabelMapJSON} from "../../Quantification/QuantificationResultJSON";
import BasicEventRMChip from "../Chips/BasicEventRMChip";
import {WrappedComponentProps} from "react-intl";
import {TreeContext} from "../../SingleHCLModelView/TreeContext";

const styles = (theme: Theme) => createStyles({
  darker: {
    background: theme.palette.type === 'dark' ? 'rgba(60,60,60,0.2)' : 'rgba(120,120,120,0.08)',
  },
  root: {
    height: '100%',
    margin: '0',
    overflow: 'auto',
    padding: '0',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
  },
  probContainer: {
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    height: '100%',
    marginTop: '0',
  },
  labelProb: {
    fontSize: '2rem',
    userSelect: 'all',
  },
  rootProb: {
    padding: '24px 0px',
  },
  cutsetChip: {
    margin: `0px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
  },
  cutsetRowItem: {
    flexDirection: 'row',
  },
  cutsetRow: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rowItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  subcomponent: {
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
    background: 'rgba(0, 0, 0, 0.03)',
  },
});


interface Props extends WithStyles<typeof styles>, WrappedComponentProps {
  noSlide: boolean;
  title: string;
  loading: boolean;
  loadingText: string;
  noDataText: string;
  treeType: string;
  sequenceName: string;
  importanceData: string;
  map: QRLabelMapJSON;
}

interface tableCellData {
  // cutset: Array<string>;
  // probability: number;
  // ranking: number;
  Conditional: number;
  Criticality: number;
  Diagnostic: number;
  Marginal: number;
  Potential: number;
  RAW: number;
  RRW: number;
  basic_event: string;
  scenario: string;
}

interface RowInfo {
  /** Materialized row of data */
  row: any;

  /** The post-accessed values from the original row */
  rowValues: any;

  /** The index of the row */
  index: number;

  /** The index of the row relative to the current page */
  viewIndex: number;

  /** The size of the page */
  pageSize: number;

  /** The index of page */
  page: number;

  /** The nesting depth (zero-indexed) */
  level: number;

  /** The nesting path of the row */
  nestingPath: number[];

  /** A boolean stating if the row is an aggregation row */
  aggregated: boolean;

  /** A boolean stating if the row is grouped by Pivot */
  groupedByPivot: boolean;

  /** An array of any expandable sub-rows contained in this row */
  subRows: any[];

  /** Original object passed to row */
  original: any;

  // Value from data for the given cell
  value: any;
}

const ImportanceDataTableColumns = (props: Props) => {

  const { intl, classes, map } = props;

  const styled = (item: JSX.Element) => {
    return <div className={classes.rowItem}>{item}</div>;
  };

  const getProbabilityJSX = (row: RowInfo) => (styled(<Typography align="center" color="textSecondary">{(row.value).toExponential(3)}</Typography>));

  return ([
    {
      id: 'basic_event',
      Header: (
        <Typography variant="h6" align="center">
          {/*
          // @ts-ignore */}
          {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.basic_event'}, undefined, undefined, undefined, undefined)}
        </Typography>
      ),
      accessor: (d: tableCellData) => d.basic_event,
      Cell: (row: RowInfo) => (
        <div className={classes.cutsetRow}>
          <div className={classes.cutsetRowItem}>
            <TreeContext.Consumer>
              {
                value => (
                  <BasicEventRMChip map={map} name={row.value} treeId={value.treeId} />
                )
              }
            </TreeContext.Consumer>
          </div>
        </div>
      ),
    },
    {
      id: 'conditional',
      accessor: 'Conditional',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.conditional'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'marginal',
      accessor: 'Marginal',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.marginal'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'potential',
      accessor: 'Potential',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.potential'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'criticality',
      accessor: 'Criticality',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
         // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.criticality'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'diagnostic',
      accessor: 'Diagnostic',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.diagnostic'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'raw',
      accessor: 'RAW',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.raw'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
    {
      id: 'rrw',
      accessor: 'RRW',
      Cell: getProbabilityJSX,
      Header: <Typography
        variant="h6"
        align="center"
      >
        {/*
        // @ts-ignore */}
        {intl.formatMessage({id: 'ImportanceResultView.Columns.Header.rrw'}, undefined, undefined, undefined, undefined)}
      </Typography>,
    },
  ]);
};

export default (ImportanceDataTableColumns);
